exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".xgrv{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "xgrv",
	"root": "xgrv"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./containers/contact/Contact.css
// module id = 206
// module chunks = 0